import createReducer from 'lib/createReducer';

export const SAVE_PAGE_BREAKS = 'SAVE_PAGE_BREAKS';


const initialState = {
  pages: []
};

const actionHandlers = {
  [SAVE_PAGE_BREAKS]: (state, action) => {
    const pageBreaks = action.data;

    return { pages: pageBreaks };
  }
};


export default createReducer(initialState, actionHandlers);
